module.exports = __webpack_public_path__ + "media/components/NewAsset/icons/pension-2a7106312f5e2e43dcf5b0bb613eff66.svg";